import React from "react"
import BackgroundHelper from "../../Common/BackgroundHelper"
import Verificationlink from "../../../../assets/images/lystfacelogos/verificationlinksend.svg"
import VerificationHelper from "../../Common/VerificationHelper"
import { ResendForgotPassword } from "../../../../store/actions"
import { useSelector, useDispatch } from "react-redux"
import { createSelector } from "reselect"
import withRouter from "../../../Common/withRouter"
import PropTypes from "prop-types"

const ForgotPasswordLayout = props => {
  const dispatch = useDispatch()

  const ForgetPasswordState = state => state.ForgetPassword
  const ForgotPasswordProperties = createSelector(
    ForgetPasswordState,
    ForgotPassword => ({
      loading: ForgotPassword.loading,
      forgotPasswordErrorMessage: ForgotPassword.forgotPasswordErrorMessage,
      forgotPasswordError: ForgotPassword.forgotPasswordError,
      user: ForgotPassword.user,
    })
  )
  const { user } = useSelector(ForgotPasswordProperties)

  const ResendForgotPasswordLink = () => {
    const ForgotPwd = {
      email: user,
    }
    dispatch(ResendForgotPassword(ForgotPwd, props.router.navigate))
  }

  return (
    <div>
      <BackgroundHelper
        layout={
          <VerificationHelper
            loading={props.loading}
            imgsrc={Verificationlink}
            title={"Link sent successfully!"}
            resend={ResendForgotPasswordLink}
            subtitle={
              "We've sent you a password reset link to your email. Please check spam just in case!"
            }
          />
        }
      />
    </div>
  )
}

export default withRouter(ForgotPasswordLayout)

ForgotPasswordLayout.propTypes = {
  error: PropTypes.any,
  history: PropTypes.object,
  loading: PropTypes.bool,
}
